var map = {
	"./android.svg": "3dac",
	"./appstore.svg": "c21b",
	"./arraw-right.svg": "6018",
	"./arrows.svg": "cf1f",
	"./assets-total.svg": "24c6",
	"./big-deal-icon.svg": "26d6",
	"./coAccountIcon.svg": "8477",
	"./coOrderIcon.svg": "01f8",
	"./delete.svg": "59a1",
	"./download.svg": "4dae",
	"./edit.svg": "aa46",
	"./exchangeAccountIcon.svg": "83ff",
	"./exchangeOrderIcon.svg": "1879",
	"./futures-calculate.svg": "eb3d",
	"./futures-set.svg": "2bd7",
	"./icon-asset-password.svg": "cb88",
	"./icon-auth.svg": "a1d9",
	"./icon-contact.svg": "e6c6",
	"./icon-qrcode.svg": "3764",
	"./icon-reseveMethod.svg": "a26f",
	"./icon-triangle-down.svg": "d334",
	"./icon_AndroidAPK.svg": "533e",
	"./icon_AppStore.svg": "8610",
	"./icon_IOSDownload.svg": "76d3",
	"./icon_TestFlight.svg": "6e44",
	"./ios.svg": "0842",
	"./menu-icon-system.svg": "e161",
	"./message-all.svg": "191e",
	"./message-auth.svg": "c2e4",
	"./message-offsite.svg": "42c8",
	"./message-security.svg": "b67d",
	"./message-system.svg": "fad9",
	"./message-wallet.svg": "9de2",
	"./normal-trade-icon.svg": "f8a1",
	"./otcaccount.svg": "f3b6",
	"./otcorder.svg": "8fbb",
	"./personalAccountIcon.svg": "84c1",
	"./personalApiIcon.svg": "da7f",
	"./publish-ad-icon.svg": "3976",
	"./selectbox.svg": "6e60",
	"./set.svg": "9873",
	"./transfer-icon.svg": "d15d",
	"./uploadPhotoIcon.svg": "0949",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";